import React, { FC, memo } from 'react';

import { Widget } from 'app/design-system/components/Widget/Widget';

import NoDataImage from './image/no-data.svg';

import styles from './PromotionNoData.module.scss';

type PromotionNoDataProps = {
  title?: string;
};

const PromotionNoData: FC<PromotionNoDataProps> = memo(({ title }) => {
  return (
    <Widget className={styles.root}
            contentClassName={styles.content}>
      <img src={NoDataImage}
           width="200"
           height="200"
           className={styles.noDataPic}
           alt={title} />

      <h5 className={styles.title}>{title}</h5>
    </Widget>
  );
});

export default PromotionNoData;
